module.exports = __webpack_public_path__ + "static/media/Buildershape.9cf1a38a.svg";